export const LANGUAGE = {
  VIETNAMESE: 'vi',
  ENGLISH: 'en',
  JAPANESE: 'ja',
};

export const AUTH_CONFIG = {
  authType: 'cookie',
  authName: '_auth',
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === 'https:',
  // cookieSecure: false,
};

export const THEME_CONFIG = {
  token: {
    colorPrimary: '#3d6a9e',
    colorInfo: '#3d6a9e',
    // motion: false,
  },
  components: {
    Select: {
      // colorText: '#3d6a9e',
      // borderRadius: '6px',
    },
    DatePicker: {
      borderRadius: '4px',
    },
  },
};

export const THEME = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const PASS_CODE_REQUIRE_LENGTH = 6;

export const TABLE_SIZE = 'small';

export const BASE_COLOR = '#3d6a9e';

export const SELECTION_TYPE = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
};

export const MESSAGE_TYPE = {
  ERROR: -1,
  SUCCESS: 0,
  WARNING: 1,
  INFO: 2,
};

export const EXPORT_FILE = {
  HEADER: {
    FONT_NAME: 'Times New Roman',
    FONT_SIZE: 12,
    HORIZONTAL: 'center',
    VERTICAL: 'center',
    BACKGROUND: '3D6A9EFF',
    COLOR: 'FFFFFFFF',
  },
  BODY: {
    FONT_NAME: 'Times New Roman',
    FONT_SIZE: 12,
    HORIZONTAL: 'center',
    VERTICAL: 'center',
  },
};

export const HUB_ID = {
  ROOM_MAP: 'RoomMap',
  ROOM_PLAN: 'RoomPlan',
  COMPANY: 'Company',
  ROOM_ASSIGNMENT: 'RoomAssignment',
  ALL: 'All',
  CHECKOUT: 'Checkout',
  CMS: {
    EXELY: {
      BOOKING: 'BookingExely',
    },
  },
};

export const HUB_EVENT = {
  CANCEL_CHECKIN: 'CancelCheckin',
  UPDATE_ROOM_STATUS: 'UpdateRoomStatus',
  ADD_COMPANY: 'AddCompany',
  EDIT_COMPANY: 'EditCompany',
  CHANGE_ROOM: 'ChangeRoom',
  EDIT_DEPARTURE: 'EditDeparture',
  CHECK_IN: 'CheckIn',
  CREATE_NEW: 'CreateNew',
  CANCEL_ROOM: 'CancelRoom',
  DELETE_ROOM: 'DeleteRoom',
  DO_NOT_MOVE: 'DoNotMove',
  OPEN_DO_NOT_MOVE: 'OpenDoNotMove',
  SPLIT_ROOM: 'SplitRoom',
  BEGIN_LOCK: 'BeginLock',
  UNLOCK: 'UnLock',
  MOVE_ROOM: 'MoveRoom',
  RESIZED_ROOM: 'ResizedRoom',
  HK_UPDATE_ROOM_STATUS: 'HKUpdateRoomStatus',
  LOCK_ROOM_OOO: 'LockRoomOOO',
  LOCK_ROOM_OOS: 'LockRoomOOS',
  SAVE_ROOM_SCHEDULE: 'SaveRoomSchedule',
  DELETE_ROOM_SCHEDULE: 'DeleteRoomSchedule',
  UPDATE_BOOKING_ROOM: 'UpdateBookingRoom',
  CMS: {
    EXELY: {
      GET_BOOKING: 'GetBookingExely',
      SAVE_ROOM: 'SaveRoomExely',
    },
  },
  END_OF_DAY: 'EndOfDay',
  START_END_OF_DAY: 'StartEndOfDay',
  ROOM_TYPE_MAPPING_EXELY_ERROR: 'RoomTypeMappingExelyError',
  CHECKIN_FOR_WALKIN: 'CheckInForWalkin',
};

export const PERMISSION_ROLE = {
  ROOM_MAP: 'ROOMMAP',
};

export const RANDOM_CHARACTER = {
  ALPHABET_NUMBER:
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
  ALPHABET_UPPERCASE_NUMBER: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
  ALPHABET_LOWERCASE_NUMBER: 'abcdefghijklmnopqrstuvwxyz0123456789',
};

export const CURRENCY_CODE = {
  VND: 'VND',
  USD: 'USD',
};

export const DB_VALUE = {
  BIT_TRUE: '1',
  STR_TRUE: 'true',
  BIT_FALSE: '0',
  STR_FALSE: 'false',
  INT_TRUE: 1,
  INT_FALSE: 0,
};

export const USERNAME = {
  ADMIN: 'admin',
};

export const DEPARTMENT = {
  FB: 'FB',
};

export const FIXED_PAYMENT_METHOD = ['AC', 'CA', 'CL'];

export const FIXED_SERVICE_ID = ['DP'];

export const THOUSANDS_SEPARATOR = '.';

export const DECIMAL_SEPARATOR = ',';

export const EVERY_MINUTES_SCHEDULE = '* * * * *';

export const EVERY_DAYS_TWO_HOURS = '0 2 * * *';

export const ACTION = {
  ADD: 2,
  EDIT: 1,
};

export const RECAPTCHA_ACTION = {
  SUBMIT: 'submit',
};

export const DEFAULT_TIMEZONE = 'Asia/Ho_Chi_Minh';
